module.exports = __webpack_public_path__ + "media/pyro-l.daacfbfa.mp4";